import { updateCurrentTrack as update } from './slice';
import { AppThunk } from '../../../app/store';
import { TitrationModel } from '../../../models';

export const updateCurrentTrack =
  (currentTrack: TitrationModel): AppThunk =>
  async dispatch => {
    dispatch(update(currentTrack));
  };
